export const Level1AccordionHeaderHeight = "80px";
export const Level2AccordionHeaderHeight = "44px";
